if (!customElements.get('sticky-atc')) {
  class StickyAtc extends HTMLElement {
    connectedCallback() {
      this.target = document.querySelector('.product-form__submit, .pack-deal__submit');
      if (!this.target) {
        this.hidden = true;
        return;
      }

      this.scrolledPastTarget = false;
      this.footerVisible = false;

      this.button = this.querySelector('[data-sticky-atc-button]');
      this.button?.addEventListener('click', () => this.scrollToTarget());

      this.targetObserver = new IntersectionObserver((entries) => {
        const entry = entries[0];
        this.scrolledPastTarget = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.updateVisibility();
      });
      this.targetObserver.observe(this.target);

      this.footer = document.querySelector('footer');
      if (this.footer) {
        this.footerObserver = new IntersectionObserver((entries) => {
          this.footerVisible = entries[0].isIntersecting;
          this.updateVisibility();
        });
        this.footerObserver.observe(this.footer);
      }
    }

    disconnectedCallback() {
      this.targetObserver?.disconnect();
      this.footerObserver?.disconnect();
    }

    updateVisibility() {
      this.classList.toggle('sticky-atc--visible', this.scrolledPastTarget && !this.footerVisible);
    }

    scrollToTarget() {
      const rect = this.target.getBoundingClientRect();
      const visibleHeight = window.innerHeight - this.offsetHeight;
      const top = window.scrollY + rect.top - visibleHeight * 0.7;
      smoothScrollTo(top);
    }
  }

  customElements.define('sticky-atc', StickyAtc);
}

function smoothScrollTo(targetTop, duration = 500) {
  const startTop = window.scrollY;
  const distance = targetTop - startTop;
  const startTime = performance.now();
  const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

  function step(now) {
    const elapsed = Math.min((now - startTime) / duration, 1);
    window.scrollTo(0, startTop + distance * easeOutCubic(elapsed));
    if (elapsed < 1) requestAnimationFrame(step);
  }

  requestAnimationFrame(step);
}
